import React from "react";

const AgentHR = () => <hr className="AgentHR" />;

export default AgentHR;
